import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/authSlice";
import { logoutUser } from "../../redux/authSlice";

export function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logoutUser())
      .unwrap()
      .then(() => {
        navigate("/"); // Navigate only after logout completes
      })
      .catch((error) => console.error("Logout failed:", error));
  };

  return (
    <header className="chroma-header">
      <span>Logo</span>
      <div className="header-btn-bar">
        {/* <button
          onClick={() =>
            console.log("Optional for quick theme update.  Default to system")
          }
        >
          Theme
        </button> */}
        <button onClick={() => handleLogout()}>Logout</button>
      </div>
    </header>
  );
}
